import { useCallback } from 'react';
import { useRequest } from './useRequest';
import {
  DiagnosticoResponse,
  ValidacaoExtracaoRequest,
  ValidacaoExtracaoResponse
} from '../types/diagnostico';

export function useDiagnostico() {
  const diagnosticoRequest = useRequest<DiagnosticoResponse>();
  const extracoesRequest = useRequest<DiagnosticoResponse>();
  const validacaoRequest = useRequest<ValidacaoExtracaoResponse>();

  const fetchDiagnostico = useCallback(async (projetoId: number) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/api/projetos/${projetoId}/evento/extracoes`;
    await diagnosticoRequest.execute(url);
  }, [diagnosticoRequest]);

  const fetchExtracoesEvento = useCallback(async (projetoId: number) => {
    await extracoesRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/projetos/${projetoId}/extracoes`, {
      method: 'POST',
    });
  }, [extracoesRequest]);

  const validarExtracao = useCallback(async (data: ValidacaoExtracaoRequest) => {
    await validacaoRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/extracoes/validar`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  }, [validacaoRequest]);

  return {
    // Estados para diagnóstico geral
    diagnostico: diagnosticoRequest.data,
    diagnosticoLoading: diagnosticoRequest.loading,
    diagnosticoError: diagnosticoRequest.error,

    // Estados para extrações de evento (POST)
    extracoesEvento: extracoesRequest.data,
    extracoesLoading: extracoesRequest.loading,
    extracoesError: extracoesRequest.error,

    // Estados para validação
    validacaoLoading: validacaoRequest.loading,
    validacaoError: validacaoRequest.error,
    validacaoSuccess: validacaoRequest.data?.sucesso,

    // Funções
    fetchDiagnostico,
    fetchExtracoesEvento,
    validarExtracao,
  };
}